import { StatusBadge } from "@/components/StatusBadge";
import { fmtDate } from "@/lib/api";

export function ProgressBar({ value, testid }) {
  const v = Math.max(0, Math.min(100, value || 0));
  return (
    <div className="h-2 w-full rounded-full bg-slate-100 overflow-hidden" data-testid={testid}>
      <div className="h-full rounded-full bg-brand-600 transition-[width] duration-500" style={{ width: `${v}%` }} />
    </div>
  );
}

function Kpi({ label, value, tone = "text-slate-800", testid }) {
  return (
    <div className="rounded-lg border bg-white px-3 py-2">
      <p className="text-[10px] uppercase font-mono text-slate-400">{label}</p>
      <p className={`text-lg font-bold font-head ${tone}`} data-testid={testid}>{value}</p>
    </div>
  );
}

export default function TechSummary({ file, summary }) {
  const s = summary || {};
  return (
    <div className="space-y-3" data-testid="tech-summary">
      <div className="rounded-xl border bg-brand-50/60 p-4">
        <div className="flex items-end justify-between mb-2">
          <p className="text-xs uppercase font-mono text-brand-700 tracking-wide">Avancement du projet</p>
          <p className="text-3xl font-head font-bold text-brand-700" data-testid="tech-progress-value">{s.avancement || 0} %</p>
        </div>
        <ProgressBar value={s.avancement} testid="tech-progress-bar" />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2 text-sm">
        <div className="rounded-lg border bg-white px-3 py-2"><p className="text-[10px] uppercase font-mono text-slate-400">Statut technique</p><StatusBadge value={file.statut} /></div>
        <Kpi label="Responsable technique" value={file.responsable_name || "—"} tone="text-slate-700 text-sm" />
        <Kpi label="Technicien affecté" value={file.technicien_name || "Non affecté"} tone="text-slate-700 text-sm" testid="tech-kpi-technicien" />
        <Kpi label="Localisation" value={file.chantier_adresse || "—"} tone="text-slate-700 text-sm" />
        <Kpi label="Contrat lié" value={file.contract_numero || "—"} tone="text-slate-700 text-sm" />
        <Kpi label="Conducteur de travaux" value={file.conducteur_name || "—"} tone="text-slate-700 text-sm" />
        <Kpi label="Chantier" value={file.chantier_nom || "—"} tone="text-slate-700 text-sm" />
        <Kpi label="Démarrage" value={file.date_demarrage ? fmtDate(file.date_demarrage) : "—"} tone="text-slate-700 text-sm" />
        <Kpi label="Fin prévue" value={file.date_fin_prevue ? fmtDate(file.date_fin_prevue) : "—"} tone="text-slate-700 text-sm" />
      </div>
      <div className="grid grid-cols-3 md:grid-cols-7 gap-2">
        <Kpi label="Tâches" value={s.nb_taches || 0} testid="tech-kpi-tasks" />
        <Kpi label="Terminées" value={s.taches_terminees || 0} tone="text-emerald-600" testid="tech-kpi-done" />
        <Kpi label="En retard" value={s.taches_retard || 0} tone={s.taches_retard ? "text-rose-600" : "text-slate-800"} testid="tech-kpi-late" />
        <Kpi label="Artisans" value={s.artisans || 0} testid="tech-kpi-artisans" />
        <Kpi label="Ouvriers" value={s.ouvriers || 0} testid="tech-kpi-ouvriers" />
        <Kpi label="Incidents" value={s.incidents_ouverts || 0} testid="tech-kpi-incidents" />
        <Kpi label="Réserves" value={s.reserves_ouvertes || 0} testid="tech-kpi-reserves" />
      </div>
    </div>
  );
}
